<template>
  <div
    :class="$route.name === `Company Login` || $route.name === `Student Login` || $route.name === `Forgot password` ? `bg-gradient-faculty fit-page` :  $route.name === `Verify Email` ? `bg-gradient-engineer-regist fit-page` : $route.name === `Company Register` ? `bg-gradient-engineer-regist` : `fit-page`"
  >
    <fade-transition :duration="100" origin="center top" mode="out-in" >
      <router-view />
    </fade-transition>
  </div>

</template>

<script>
export default {
  data() {
    return {
    };
  }
};

</script>

<style scoped>
  .fit-page {
    height: 100vh;
  }
</style>